import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  useEffect(() => {
    document.title = 'AMK Solutions';
  }, []);
  return <LandingPage data-id="element-0" />;
}